export default "__VITE_ASSET__50fe3f02__"